import React from "react";
import HomeIcon from "@material-ui/icons/Home";

export default function NavBarAdmin({ user, token }) {
  return (
    <div className="col-md-12 w-100 mx-0 px-0">
      <nav
        className="navbar navbar-expand-lg navbar-dark bg-primary mx-0"
        // styles={{
        //   backgroundColor: "#3F51B5 !important",
        // }}
      >
        <a className="navbar-brand ml-5 d-flex align-items-center" href="/">
          <HomeIcon />
          &nbsp;&nbsp; <p className="my-0 font-weight-bold">Home</p>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto mr-5">
            <li className="nav-item dropdown">
              <a
                className="nav-link text-white"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i className="fa fa-bell"></i>
              </a>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <a className="dropdown-item" href="#">
                  Notification 1
                </a>
                <a className="dropdown-item" href="#">
                  Notification 2
                </a>
              </div>
            </li>
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle text-white"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {user.name}
              </a>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <a className="dropdown-item" href="/userPage/profile">
                  Profile
                </a>
                <button
                  onClick={() => {
                    sessionStorage.removeItem("token");
                    window.location.replace(`https://server.abnca.in`);
                  }}
                  className="dropdown-item px-4"
                >
                  Logout
                </button>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      {/* <AppBar position="static" style={{ marginBottom: "5px" }}>
        <Toolbar>
          <IconButton
            href="/"
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="home"
          >
            <HomeIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            User Page
          </Typography>
          <div>
            <Button
              className={classes.button_menu}
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              {user.name}
              <ExpandMoreIcon />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  localStorage.removeItem("token");
                  window.location.replace(`https://server.abnca.in`);
                }}
              >
                Logout
              </MenuItem>
            </Menu>
          </div>
        </Toolbar>
      </AppBar> */}
    </div>
  );
}
